<template>
  <el-dialog
    title="订单详情"
    :visible.sync="dialogVisible"
    width="60%"
    :before-close="handleClose"
    custom-class="order_info_modal"
    :append-to-body="true"
  >
    <!-- :append-to-body="true" -->
    <order-info ref="orderInfo" @close="close" @ok="$emit('ok')"></order-info>
    <span slot="footer" class="dialog-footer" style="display: none">
      <el-button @click="dialogVisible = false">取 消</el-button>
      <el-button type="primary" @click="dialogVisible = false">确 定</el-button>
    </span>
  </el-dialog>
</template>

<script>
import orderInfo from "./../order_info";

export default {
  components: {
    orderInfo,
  },
  data() {
    return {
      dialogVisible: false,
      orderid: "",
    };
  },

  methods: {
    open(item = {}, refund) {
      this.orderid = item.id;
      this.dialogVisible = true;
      this.$nextTick(() => {
        this.$refs.orderInfo.orderid = "";
        if (refund) {
          this.$refs.orderInfo.orderid = item.orderId;
          this.$refs.orderInfo.refundId = item.id;
          this.$refs.orderInfo.init();
        } else {
          this.$refs.orderInfo.orderid = item.id;
          this.$refs.orderInfo.init();
        }
      });
    },
    // 跳转异常记录
    isAbnormal() {
      this.$nextTick(() => {
        this.$refs.orderInfo.orderTab.map((i) => {
          i.isSelected = false;
        });
        this.$refs.orderInfo.orderTab[4].isSelected = true;
      });
    },
    // 跳转退款
    isRefund() {
      this.$nextTick(() => {
        this.$refs.orderInfo.orderTab.map((i) => {
          i.isSelected = false;
        });
        this.$refs.orderInfo.orderTab[2].isSelected = true;
      });
    },
    close() {
      console.log(1111);
      this.dialogVisible = false;
    },
    // 模态框关闭回调
    handleClose() {
      this.dialogVisible = false;
      console.log("模态框关闭");
    },
  },
};
</script>

<style lang='scss'>
// #orderlist {
.el-dialog__wrapper {
  .order_info_modal {
    width: 1152px !important;
    margin-top: 5vh !important;
    // &>.el-dialog__header{
    //   display: none;
    // }
  }
}
.order_info_modal {
  .el-dialog {
    width: 1000px !important;
  }
  .el-dialog__body,
  .el-dialog__footer {
    background: #eef0f3;
    margin: 0;
  }
  .el-dialog__body {
    // padding: 20px 24px !important;
    padding: 10px 24px !important;
  }
  .el-dialog__header {
    height: 54px;
    padding: 19px 24px !important;
    background: #f9fafa;
    .el-dialog__title {
      font-size: 16px;
      line-height: 16px;
    }
    .el-dialog__headerbtn {
      top: 16px;
    }
  }
  .gengjiun {
    background: #fff;
    padding: 0 20px 20px;
    .modal-tit {
      height: 54px;
      padding: 20px 0 15px 0;
      font-size: 14px;
      line-height: 19px;
      color: #5e6066;
      font-weight: bold;
    }
  }
}
// }
</style>
